import { useEffect, useState } from 'react';
import { Warning, X, Info, WarningOctagon } from '@phosphor-icons/react';
import { getSystemNotice } from '../services/api';

const SEVERITY_STYLES = {
  info: 'bg-blue-50 border-blue-200 text-blue-900',
  warning: 'bg-amber-50 border-amber-300 text-amber-900',
  critical: 'bg-red-50 border-red-300 text-red-900',
};

const SEVERITY_ICON = {
  info: Info,
  warning: Warning,
  critical: WarningOctagon,
};

export default function SystemNoticeBanner() {
  const [notice, setNotice] = useState(null);
  const [dismissed, setDismissed] = useState(false);

  useEffect(() => {
    let cancelled = false;
    const load = async () => {
      try {
        const res = await getSystemNotice();
        if (cancelled) return;
        if (res.data?.active && res.data?.message) {
          // Dismiss-Status per Nachrichten-Hash (sodass neuer Hinweis wieder erscheint)
          const key = `notice-dismissed:${res.data.updated_at || res.data.message}`;
          const isDismissed = sessionStorage.getItem(key) === '1';
          setNotice(res.data);
          setDismissed(isDismissed);
        } else {
          setNotice(null);
        }
      } catch {
        setNotice(null);
      }
    };
    load();
    const id = setInterval(load, 60000); // refresh every 60s
    return () => { cancelled = true; clearInterval(id); };
  }, []);

  if (!notice || !notice.active || dismissed) return null;

  const severity = SEVERITY_STYLES[notice.severity] || SEVERITY_STYLES.info;
  const Icon = SEVERITY_ICON[notice.severity] || Info;

  const handleDismiss = () => {
    const key = `notice-dismissed:${notice.updated_at || notice.message}`;
    sessionStorage.setItem(key, '1');
    setDismissed(true);
  };

  return (
    <div
      className={`border-b ${severity} px-4 py-3 flex items-center gap-3`}
      role="status"
      data-testid="system-notice-banner"
    >
      <Icon weight="fill" className="w-5 h-5 flex-shrink-0" />
      <div className="flex-1 min-w-0">
        <p className="text-sm font-medium leading-snug" data-testid="system-notice-message">
          <span className="font-bold mr-2">Hinweis:</span>
          {notice.message}
          {notice.scheduled_for && (
            <span className="ml-2 text-xs opacity-80">
              · Geplant: {notice.scheduled_for}
            </span>
          )}
        </p>
      </div>
      <button
        type="button"
        onClick={handleDismiss}
        className="flex-shrink-0 p-1 hover:opacity-75 rounded"
        aria-label="Hinweis schließen"
        data-testid="system-notice-dismiss"
      >
        <X weight="bold" className="w-4 h-4" />
      </button>
    </div>
  );
}
